export class ExceptionText {
  static EMAIL_SENT_FORGOT_PASSWORD = 'Problem happened, Email sent to you for your password recovery.';
  static USER_NOT_EXISTS = 'Entered user does not exist in the system.';
  static EMAIL_VALIDATION_ERROR = 'Please enter correct email.';
  /* tslint:disable */
  static PROFILE_MISSING_ERROR = 'There is a problem with your profile which is missing in OKTA please do authentication process once more.';
  static EMAIL_SENT_UNLOCK_ACCOUNT = 'Problem happened, Email sent to you to unlock your account.';
  static TOKEN_GENERATION_TIME_ERROR = 'Problem happened in the token generation time, we are trying to fix that in the meantime please reload your page.';
  static GENERAL_ERROR = 'There was a some problem happened in your action time, we are trying to solve that in the meantime please try once more or contact please to our customer service.';
  static ACCEPT_TERMS = 'Please accept to the Swift Terms of use.'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/helpers/exception-text.ts